<template>
  <div>
    <app-content>
      <h1>Works</h1>
      <div class="filter">
        <div class="filter-label">Filter:&nbsp;</div>
        <div
          :class="{ 'filter-item': true, 'filter-selected': filter.value }"
          @click="filterToggle(filter.key)"
          v-for="filter in filters"
          :key="filter.key"
        >
          <span>{{ filter.key }}</span>
        </div>
      </div>
      <work-cards :works="filterdWorks()" :on-click-card="handleClickCard" />
      <div class="skills-link">
        <leading-link to="/skills" size="32">Skills</leading-link>
      </div>
    </app-content>
    <modal
      :wrapper-style="getModalWrapperStyle()"
      :open="modalOpen"
      :title="validateModalWork('title')"
      :on-close="handleModalClose"
    >
      <div class="work-modal-content">
        <div class="work-modal-detail" v-html="validateModalWork('detail')" />
        <div class="repository-link" v-if="validateModalWork('repository')">
          <a :href="validateModalWork('repository')" target="_blank">Repository</a>
        </div>
        <div class="url-link" v-if="validateModalWork('url')">
          <a :href="validateModalWork('url')" target="_blank">Link</a>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import AppContent from 'src/components/AppContent'
import LeadingLink from 'src/components/LeadingLink'
import Modal from 'src/components/Modal'
import WorkCards from './components/WorkCards'
import data from './data'

export default {
  data: () => {
    return {
      modalOpen: false,
      modalWork: null,
      ...data
    }
  },
  methods: {
    filterToggle(key) {
      this.filters.forEach(filter => {
        if (filter.key === key) {
          filter.value = !filter.value
        } else {
          filter.value = false
        }
      })
    },
    filterdWorks() {
      const setFilter = this.filters.filter(filter => filter.value)
      const filterdWorkList = []
      if (setFilter.length === 0) {
        return this.works
      }
      this.works.forEach(work => {
        setFilter.forEach(filter => {
          if (filter.key === work.kind) {
            filterdWorkList.push(work)
          }
        })
      })
      return filterdWorkList
    },
    handleClickCard(work) {
      this.modalWork = work
      this.modalOpen = true
    },
    handleModalClose() {
      this.modalOpen = false
    },
    validateModalWork(key) {
      if (this.modalWork) {
        return this.modalWork[key]
      }
      return ''
    },
    getModalWrapperStyle() {
      return 'position: relative; width: 70%; max-width: 400px; height: auto;'
    }
  },
  components: {
    AppContent,
    LeadingLink,
    Modal,
    WorkCards
  }
}
</script>

<style scoped>
.app-content-override {
  position: relative;
}

.filter {
  display: flex;
  width: 100%;
  flex-direction: row;
  margin-bottom: 16px;
}

.filter-label {
  padding: 8px;
  font-size: 18px;
  color: rgb(117, 117, 117);
}

.filter-item {
  padding: 8px;
  font-size: 18px;
  color: rgb(117, 117, 117);
  cursor: pointer;
}

.filter-item span:after {
  width: 0;
  height: 2px;
  display: block;
  content: '';
  background: rgb(117, 117, 117);
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}

.filter-selected span:after {
  width: 100%;
}

.work-modal-detail {
  padding-bottom: 64px;
}

.repository-link {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100px;
  margin: 32px;
  text-align: center;
}

.url-link {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100px;
  margin: 32px;
  text-align: center;
}

.skills-link {
  display: flex;
  margin-top: 64px;
  margin-bottom: 64px;
  justify-content: center;
}

@media screen and (min-width: 1024px) {
  .filter-item:hover span:after {
    width: 100%;
  }
}
</style>
